import React from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Ourprojects from "./components/Ourprojects";
import Contact from "./components/Contact";
import ContractorLogin from "./Admin/ContractorLogin";
import Projectsmanagement from "./Admin/Projectsmanagement";
import ContactManagement from "./Admin/ContactManagement";

// --- Layouts ---
function PublicLayout() {
  return (
    <div className="text-gray-800">
      <Header />
      <main className="pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

// No header/footer (login, bare pages, etc.)
function NoChromeLayout() {
  return (
    <main className="text-gray-800">
      <Outlet />
    </main>
  );
}

// Protected wrapper (no header/footer)
function ProtectedLayout() {
  return (
    <main className="text-gray-800">
      <Outlet />
    </main>
  );
}

// --- Simple auth gate ---
// Replace this with your real auth check (context, redux, etc.)
function isAuthed() {
  return !!localStorage.getItem("auth_token");
}

function ProtectedRoute({ children }) {
  if (!isAuthed()) {
    // not logged in → send to login
    return <Navigate to="/Admin/ContractorLogin" replace />;
    }
  return children;
}

export default function App() {
  return (
    <Routes>
      {/* Public pages with Header/Footer */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Ourprojects />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      {/* Login or other bare pages (no Header/Footer) */}
      <Route element={<NoChromeLayout />}>
        <Route path="/Admin/ContractorLogin" element={<ContractorLogin />} />
        <Route path="/Admin/ContactManagement" element={<ContactManagement />} />
        <Route path="/Admin/Projectsmanagement" element={<Projectsmanagement />} />
      </Route>

      {/* Protected routes (no Header/Footer) */}
      <Route
        element={
          <ProtectedRoute>
            <ProtectedLayout />
          </ProtectedRoute>
        }
      >
        {/* examples — add your real admin pages here */}
        {/* <Route path="/admin" element={<div className="p-6">Admin Dashboard</div>} /> */}
        <Route path="/Admin/ContactManagement" element={<ContactManagement />} />
        <Route path="/Admin/Projectsmanagement" element={<Projectsmanagement />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}